import { func, shape } from 'prop-types'

const i18nType = shape({
  _: func.isRequired,
})

export { i18nType }
